import * as SubframeCore from "@subframe/core";

export const twClassNames = SubframeCore.createTwClassNames([
  "text-caption",
  "text-caption-bold",
  "text-body",
  "text-body-bold",
  "text-heading-3",
  "text-heading-2",
  "text-heading-1",
  "text-monospace-body",
  "text-heading-section",
  "text-heading-subsection",
  "text-heading-4",
  "text-custom-text",
]);
